import { render } from "./banner-cookies.vue?vue&type=template&id=d7fc8248"
import script from "./banner-cookies.vue?vue&type=script&lang=js"
export * from "./banner-cookies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__